import React from "react";
import { ToastContainer, toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Define default options
const defaultToastOptions: ToastOptions = {
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

// Success Toast
export const showSuccessToast = (message: string, options?: ToastOptions) => {
  toast.success(message, { ...defaultToastOptions, ...options });
};

// Error Toast
export const showErrorToast = (message: string, options?: ToastOptions) => {
  toast.error(message, { ...defaultToastOptions, ...options });
};

// Info Toast
export const showInfoToast = (message: string, options?: ToastOptions) => {
  toast.info(message, { ...defaultToastOptions, ...options });
};

// Warning Toast
export const showWarningToast = (message: string, options?: ToastOptions) => {
  toast.warn(message, { ...defaultToastOptions, ...options });
};

// ToastContainer Component
const ToastComponent: React.FC = () => {
  return <ToastContainer />;
};

export default ToastComponent;
